import React from 'react';
import StepsProps from './StepsProps';
import Step from './Step';
import { StepWrapper } from './StepWrapper';

export default class StepsDesktop extends React.Component<StepsProps> {
    stepsWrapper: React.RefObject<HTMLDivElement>;

    constructor(props: StepsProps) {
        super(props);
        this.stepsWrapper = React.createRef();
    }

    componentDidMount() {
        if (this.stepsWrapper.current) {
            const w = this.stepsWrapper.current;
            let height = 0;
            for (let i = 0; i < w.children.length; i++) {
                const child = w.children[i];
                height = Math.max(child!.scrollHeight, height);
            }
            w.style.height = height + 'px';
        }
    }

    render() {
        const { steps, currentStep, setCurrentStep } = this.props;
        return (
            <div className="steps-desktop is-desktop-only">
                <div className="steps-desktop__list">
                    <ul className="list-style-none">
                        {steps.map((step, index) => (
                            <li key={index}>
                                <button
                                    type="button"
                                    className={`step-desktop ${currentStep === index ? 'is-active' : ''}`}
                                    onClick={() => setCurrentStep(index)}
                                >
                                    {step.headlineType
                                        ? (() => {
                                              const CustomHeadingTag = step.headlineType as keyof JSX.IntrinsicElements;
                                              return (
                                                  <CustomHeadingTag className="custom-headline-type-inherit">
                                                      {step.headline}
                                                  </CustomHeadingTag>
                                              );
                                          })()
                                        : step.headline}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div ref={this.stepsWrapper} className="steps-desktop__steps-wrapper">
                    {steps.map((step, index) => {
                        const nextHeadline = steps?.[index + 1]?.headline;
                        return (
                            <StepWrapper key={index} isActive={index === currentStep} isDown={index - currentStep > 0}>
                                <Step
                                    content={step}
                                    next={() => setCurrentStep(currentStep + 1)}
                                    nextHeadline={nextHeadline}
                                />
                            </StepWrapper>
                        );
                    })}
                </div>
            </div>
        );
    }
}
